module.exports = __webpack_public_path__ + "img/icon_map_63_on_101.909cb65e.png";